import React, { PropsWithChildren } from 'react'
import { HStack } from '../../parts/bases/HStack'
import { GlobalNavigationLayout } from '../../parts/commons/GlobalNavigationLayout'
import DeafultMyPageHeaderBackgroundImage from '@/public/images/myPageDefaultBackgroundImage.png'
import Image, { StaticImageData } from 'next/image'
import { Center } from '../../parts/bases/Center'
import { Text } from '../../parts/bases/Text'
import { VStack } from '../../parts/bases/VStack'
import { Grid } from '../../parts/bases/Grid'
import Link from 'next/link'
import { PagePathService } from '@/src/services/PagePathService'
import { Space } from '../../parts/bases/Space'
import { Head } from '../../parts/commons/Head'
import IconEditUser from '@/public/images/iconEditUser.png'
import WalletBgTeras from '@/public/images/walletBgTeras.png'
import WalletBgAKIR from '@/public/images/walletBgAKIR.png'
import WalletBgAKV from '@/public/images/walletBgAKV.png'
import WalletGridTeras from '@/public/images/walletGridTeras.png'
import WalletGridAKV from '@/public/images/walletGridAKV.png'
import WalletGridAKIR from '@/public/images/walletGridAKIR.png'
import WalletGradientTeras from '@/public/images/walletGradientTeras.png'
import WalletGradientAKIR from '@/public/images/walletGradientAKIR.png'
import WalletGradientAKV from '@/public/images/walletGradientAKV.png'
import Teras from '@/public/images/teras.png'
import AKIR from '@/public/images/akir.png'
import AKV from '@/public/images/akv.png'
import RefreshIcon from '@/public/images/walletRefresh.png'
import { Absolute } from '../../parts/bases/Absolute'
import { NftState } from './query.generated'
import { PinkNeonButton } from '../../parts/buttons/PinkNeonButton'
import { JunkConvertDialog } from '../../dialogs/JunkConvertDialog'
import { UserIcon } from '../../parts/icons/UserIcon'
import { IconEditDialog } from '../../dialogs/IconEditDialog'
import { Clickable } from '../../parts/bases/Clickable'
import { MAX_USERNAME_LENGTH } from '@/src/assets/constants'
import { AKVWithdrawDialog } from '../../dialogs/AKVWithdrawDialog'
import { AKVDepositDialog } from '../../dialogs/AKVDepositDialog'
import { StarArea } from '../../parts/nft/StarArea'

export type Props = {
  state: 'Default' | 'Edit_Icon' | 'Edit_Name' | 'Loading'
  onClickEditIcon: () => void
  onSaveIcon: () => void
  onClickCancel: () => void
  userName: string
  userWalletAddress: string
  onClickEditName: () => void
  inputUserName: string
  onChangeUserName: (s: string) => void
  onClickNameSave: () => void
  terasBalance: string
  onClickRefreshBalances: () => void
  onClickRefreshAkv: () => void
  akvWalletBalance: string
  akvInAkiverseBalance: string
  akvState: 'Approve' | 'Deposit'
  visibleDepositAkvDialog: boolean
  onClickDepositAkv: () => void
  visibleWithdrawAkvDialog: boolean
  onClickWithdrawAkv: () => void
  onClickAKVComplete: () => Promise<void>
  onClickClose: () => void
  nfts: Array<
    | {
        type: 'GameCenter'
        id: string
        name: string
        imageUrl: string
        linkUrl: string
        state: NftState
      }
    | {
        type: 'AracdeMachine'
        id: string
        name: string
        imageUrl: string
        linkUrl: string
        state: NftState
      }
    | {
        type: 'ArcadeParts'
        id: string
        name: string
        imageUrl: string
        linkUrl: string
        state: NftState
        rarity: number
      }
  >
  junks: Array<{
    id: string
    name: string
    amount: number
    rarity: number
    imageUrl: string
    junksPerPart: number
    disabled: boolean
  }>
  convertingJunkId?: string
  onClickJunkConvertDialogClose: () => void
  onCompletedJunkConvert: () => void
  onClickConvert: (junkId: string) => void
}

export const Layout = (props: Props) => {
  return (
    <>
      <Head title="My Page" />
      <GlobalNavigationLayout activeMenu="MyPage">
        <VStack>
          <HStack className="p-9">
            <h1 className="text-4xl font-bold text-white" style={{ textShadow: '#805BE7 1px 0 10px' }}>
              My Page
            </h1>
          </HStack>
          <HStack className="relative h-[300px] w-full">
            <Image src={DeafultMyPageHeaderBackgroundImage} alt="" objectFit="cover" />
            <HStack className="absolute top-0 left-0 h-full w-full px-8 py-10">
              <HStack className="h-full w-full items-center bg-black bg-opacity-60 py-10 px-8 backdrop-blur-sm">
                <UserIcon onClickEditIcon={props.onClickEditIcon} />
                <Text className="ml-8 text-2xl font-bold text-neon-blue">{props.userName}</Text>
                <Clickable className="ml-3" onClick={props.onClickEditName}>
                  <Image src={IconEditUser} width={24} height={24} alt="Edit User" />
                </Clickable>
              </HStack>
            </HStack>
          </HStack>
          <VStack className="my-4 px-9">
            <h2 className="text-2xl font-bold text-neon-blue">Wallet Summary</h2>
            <HStack className="mt-4 h-[270px] gap-x-5">
              <TerasArea terasBalance={props.terasBalance} onClickRefresh={props.onClickRefreshBalances} />
              <AKIRArea />
              <AKVArea
                userWalletAddress={props.userWalletAddress}
                inAkiverseBlance={props.akvInAkiverseBalance}
                walletBalance={props.akvWalletBalance}
                onClickDeposit={props.onClickDepositAkv}
                onClickWithdraw={props.onClickWithdrawAkv}
                onClickRefresh={props.onClickRefreshBalances}
              />
            </HStack>
          </VStack>
          <VStack className="px-9 py-4">
            <HStack>
              <h2 className="text-2xl font-bold text-neon-blue">My NFTs</h2>
              <Space />
              <Link href={PagePathService.myGameCenters()}>
                <a className="flex items-center">
                  <Text className="font-bold text-neon-blue">more</Text>
                  <Center className="relative ml-1 h-5 w-5">
                    <Image src={'/images/moreArrow.png'} alt="" layout="fill" />
                  </Center>
                </a>
              </Link>
            </HStack>
            <Grid className="mt-4 w-full grid-cols-7 gap-4">
              {props.nfts.map((nft) => (
                <Center key={nft.id} className="relative">
                  <Link href={nft.linkUrl}>
                    <a
                      className={`aspect-[3/4] w-full overflow-hidden rounded-xl border-2 border-[#805BE7] bg-black bg-gradient-to-b from-[rgba(0,0,0,0)] via-[rgba(0,0,0,0)] to-[#805BE760]`}
                    >
                      <VStack className="h-full w-full bg-[url('/images/gameCenterCellTextBg.png')] bg-repeat">
                        <div
                          className="relative aspect-square w-full bg-black bg-cover bg-center"
                          style={{ backgroundImage: `url('${nft.imageUrl}')` }}
                        >
                          {nft.type === 'ArcadeParts' && (
                            <Absolute className="bottom-1.5 left-1.5">
                              <StarArea parentKey={nft.id} rarity={nft.rarity} />
                            </Absolute>
                          )}
                        </div>
                        <VStack className="w-full p-2">
                          <Text className="flex-1 text-left text-xs font-bold text-white">{nft.name}</Text>
                          {nft.type === 'AracdeMachine' && (
                            <Text className="mt-1 flex-1 text-left text-xs text-neutral-500">{nft.id}</Text>
                          )}
                        </VStack>
                      </VStack>
                    </a>
                  </Link>
                  {nft.state !== NftState.InAkiverse ? (
                    <Absolute className="pointer-events-none h-full w-full items-center justify-center rounded-xl bg-black bg-opacity-60">
                      {nft.state !== NftState.InWallet ? (
                        <div className="h-10 w-10 animate-spin rounded-full border-[4px] border-neon-blue border-t-transparent border-opacity-70"></div>
                      ) : null}
                    </Absolute>
                  ) : null}
                </Center>
              ))}
            </Grid>
            <HStack className="mt-9">
              <h2 className="text-2xl font-bold text-neon-blue">In-World Item</h2>
              <Space />
              <Link href={PagePathService.myInWorldItems()}>
                <a className="flex items-center">
                  <Text className="font-bold text-neon-blue">more</Text>
                  <Center className="relative ml-1 h-5 w-5">
                    <Image src={'/images/moreArrow.png'} alt="" layout="fill" />
                  </Center>
                </a>
              </Link>
            </HStack>
            <Grid className="mt-4 w-full grid-cols-7 gap-4">
              {props.junks.map((junk) => (
                <Center key={junk.id} className="relative">
                  <div
                    className={`w-full overflow-hidden rounded-xl border-2 border-[#5F5B7A] bg-black bg-opacity-70`}
                  >
                    <VStack className="h-full w-full bg-[url('/images/gameCenterCellTextBg.png')] bg-repeat">
                      <div
                        className="relative aspect-square w-full bg-black bg-cover bg-center"
                        style={{ backgroundImage: `url('${junk.imageUrl}')` }}
                      >
                        <Absolute className="left-0 bottom-0 w-full flex-row items-end p-2">
                          <StarArea parentKey={junk.id} rarity={junk.rarity} />
                          <Space />
                          {!junk.disabled && junk.amount >= junk.junksPerPart ? (
                            <PinkNeonButton size="S" onClick={() => props.onClickConvert(junk.id)}>
                              Convert
                            </PinkNeonButton>
                          ) : null}
                        </Absolute>
                      </div>
                      <VStack className="h-[68px] w-full p-2">
                        <Text className="flex-1 text-left text-xs font-bold text-white">{junk.name}</Text>
                        <HStack className="w-full items-baseline justify-end">
                          <Text className="text-sm font-bold text-white">In Akiverse</Text>
                          <Text className="mx-2 text-xs font-bold text-white">x</Text>
                          <Text className="text-sm font-bold text-neon-blue">{junk.amount || '-'}</Text>
                        </HStack>
                      </VStack>
                    </VStack>
                  </div>
                </Center>
              ))}
            </Grid>
            <HStack className="mt-9">
              <h2 className="text-2xl font-bold text-neon-blue">News</h2>
            </HStack>
          </VStack>
        </VStack>
      </GlobalNavigationLayout>

      {props.state === 'Edit_Name' && (
        <Absolute className="top-0 z-[100] h-full w-screen flex-1 bg-black/60">
          <HStack className="ml-[540px] mt-[290px] h-12 items-center gap-x-6">
            <input
              defaultValue={props.userName}
              autoCapitalize="off"
              autoFocus={true}
              onChange={(e) => props.onChangeUserName(e.target.value)}
              className="mr-3 w-[340px] rounded-lg border-2 border-neutral-800 bg-black p-2 font-bold text-white caret-neon-blue outline-0 focus:border-neon-blue"
              maxLength={MAX_USERNAME_LENGTH}
            />
            <PinkNeonButton type="Sub" onClick={props.onClickCancel}>
              <Text className="text-xl font-bold text-white">Cancel</Text>
            </PinkNeonButton>
            <PinkNeonButton onClick={props.onClickNameSave} disabled={!!!props.inputUserName}>
              <Text className="text-xl font-bold text-white">Save</Text>
            </PinkNeonButton>
          </HStack>
        </Absolute>
      )}

      {props.convertingJunkId ? (
        <JunkConvertDialog
          junkId={props.convertingJunkId}
          onClickClose={props.onClickJunkConvertDialogClose}
          onCompleted={props.onCompletedJunkConvert}
        />
      ) : null}

      {props.state === 'Edit_Icon' ? (
        <IconEditDialog onSaveIcon={props.onSaveIcon} onClickCancel={props.onClickCancel} />
      ) : null}

      {props.visibleWithdrawAkvDialog ? (
        <AKVWithdrawDialog onComplete={props.onClickAKVComplete} onClickClose={props.onClickClose} />
      ) : props.visibleDepositAkvDialog ? (
        <AKVDepositDialog
          initialState={props.akvState}
          onComplete={props.onClickAKVComplete}
          onClickClose={props.onClickClose}
        />
      ) : null}
    </>
  )
}

const TerasArea = (props: { terasBalance: string; onClickRefresh: () => void }) => {
  const { terasBalance, onClickRefresh } = props
  return (
    <BaseArea
      borderClass="border-akiverse-teras"
      gradientImage={WalletGradientTeras}
      gridImage={WalletGridTeras}
      backgroundImage={WalletBgTeras}
      backgroundImageClass="aspect-[870/768] h-[200px]"
      title="Teras"
    >
      <Center className="relative ml-8 mt-2 h-[100px] w-[100px]">
        <Image src={Teras} alt="" layout="fill" />
      </Center>
      <VStack>
        <Text className="z-10 ml-4 text-xl text-white">In AKIVERSE :</Text>
        <Text className="z-10 ml-4 text-3xl font-bold text-neon-blue">
          {Number(terasBalance).toLocaleString()}
        </Text>
      </VStack>
      <Absolute className="top-2 right-2 z-10">
        <button className="relative h-8 w-8 hover:opacity-80 active:opacity-25" onClick={onClickRefresh}>
          <Image src={RefreshIcon} layout="fill" objectFit="cover" alt="" />
        </button>
      </Absolute>
    </BaseArea>
  )
}

const AKIRArea = () => {
  return (
    <BaseArea
      borderClass="border-akiverse-akir"
      gradientImage={WalletGradientAKIR}
      gridImage={WalletGridAKIR}
      backgroundImage={WalletBgAKIR}
      title="AKIR"
    >
      <Center className="relative ml-8 h-[100px] w-[100px]">
        <Image src={AKIR} alt="" layout="fill" />
      </Center>
      <VStack>
        <Text className="z-10 ml-4 text-xl font-bold text-white"></Text>
        <Text className="z-10 ml-4 text-3xl font-bold text-neon-blue">{}</Text>
      </VStack>
      <Absolute className="top-0 left-0 z-20 h-full w-full items-center justify-center bg-black bg-opacity-50">
        <Text className="mt-5 text-2xl text-akiverse-akir">COMING SOON</Text>
      </Absolute>
    </BaseArea>
  )
}

const AKVArea = (props: {
  userWalletAddress: string
  inAkiverseBlance: string
  walletBalance: string
  onClickDeposit: () => void
  onClickWithdraw: () => void
  onClickRefresh: () => void
}) => {
  const {
    userWalletAddress,
    inAkiverseBlance,
    walletBalance,
    onClickDeposit,
    onClickWithdraw,
    onClickRefresh,
  } = props
  return (
    <BaseArea
      borderClass="border-akiverse-akv"
      gradientImage={WalletGradientAKV}
      gridImage={WalletGridAKV}
      backgroundImage={WalletBgAKV}
      title="AKV"
    >
      <Center className="relative ml-8 mt-2 h-[100px] w-[100px]">
        <Image src={AKV} alt="" layout="fill" objectFit="contain" />
      </Center>
      <VStack className="-mt-10 w-full">
        <Text className="z-10 ml-4 text-xl text-white">In wallet :</Text>
        <Text className="z-10 mx-8 text-right text-3xl font-bold text-neon-blue">
          {isNaN(Number(walletBalance)) || Number(walletBalance) === 0
            ? '-'
            : Number(walletBalance).toLocaleString()}
        </Text>
        <Text className="z-10 ml-4 text-xl text-white">In AKIVERSE :</Text>
        <Text className="z-10 mx-8 text-right text-3xl font-bold text-neon-blue">
          {isNaN(Number(inAkiverseBlance)) || Number(inAkiverseBlance) === 0
            ? '-'
            : Number(inAkiverseBlance).toLocaleString()}
        </Text>
      </VStack>
      <Absolute className="bottom-5">
        <HStack className="mx-12 mt-7 gap-x-5">
          <PinkNeonButton
            type="Default"
            onClick={onClickWithdraw}
            disabled={!userWalletAddress || Number(inAkiverseBlance) < 1}
          >
            Withdraw
          </PinkNeonButton>
          <PinkNeonButton
            type="Default"
            onClick={onClickDeposit}
            disabled={!userWalletAddress || Number(walletBalance) < 1}
          >
            Deposit
          </PinkNeonButton>
        </HStack>
      </Absolute>
      <Absolute className="top-2 right-2 z-10">
        <button className="relative h-8 w-8 hover:opacity-80 active:opacity-25" onClick={onClickRefresh}>
          <Image src={RefreshIcon} layout="fill" objectFit="cover" alt="" />
        </button>
      </Absolute>
    </BaseArea>
  )
}

const BaseArea = (
  props: PropsWithChildren<{
    borderClass: string
    gradientImage: StaticImageData
    gridImage: StaticImageData
    backgroundImage: StaticImageData
    backgroundImageClass?: string
    title: string
  }>,
) => {
  const { borderClass, gradientImage, gridImage, backgroundImage, backgroundImageClass, title, children } =
    props
  return (
    <VStack className={`relative flex-1 overflow-hidden rounded-xl border-2 ${borderClass}`}>
      <Center className="absolute bottom-0 right-0 z-0 h-full w-full">
        <Image src={gradientImage} layout="fill" objectFit="cover" alt="" />
      </Center>
      <Center className="absolute bottom-0 right-0 z-0 h-full w-full">
        <Image src={gridImage} layout="fill" objectFit="cover" alt="" />
      </Center>
      <Center className={`absolute bottom-0 right-0 z-0 ${backgroundImageClass ?? 'h-full w-full'}`}>
        <Image src={backgroundImage} objectFit="cover" alt="" />
      </Center>
      <Text className="z-10 m-4 text-3xl font-bold text-neon-blue">{title}</Text>
      <HStack className="-mt-16 h-full w-full items-center">{children}</HStack>
    </VStack>
  )
}
